import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  NgZone,
} from "@angular/core";

@Component({
  selector: "icn-navbar-menu",
  templateUrl: "./navbar-menu.component.html",
  styleUrls: ["./navbar-menu.component.scss"],
})
export class NavBarMenuComponent {
  @Input() active = true;

  @Input() animateOut = false;

  @Input()
  overrideWidth: string;

  @Output() activeChange = new EventEmitter<boolean>();

  // @HostListener('mouseenter')
  // @HostListener('mouseleave')

  constructor(private zone: NgZone) {}

  onHover() {
    // this.toggleActive();
  }

  ngOnChanges(change) {
    if (change["animateOut"] && change["animateOut"]["currentValue"]) {
      this.animateMenuOut();
      return;
    }
  }

  /**
   * Animating out the
   * @return void
   */
  animateMenuOut() {
    setTimeout(() => {
      this.active = false;
      this.animateOut = false;
    }, 250);
  }

  /**
   *
   */
  toggleActive() {
    this.active = !this.active;
    this.activeChange.emit(this.active);
  }
}
